import React, { Fragment } from 'react';
import { TableRow } from '@mui/material';
import { TSCell, TSTable } from '../ui/TableStructure';

import dateFormatter from '../../utils/dateFormatter';
import { ordinalList } from '../../utils/ordinal';
import { useIsSmallDown } from '../../utils/responsive';

const ResultsByPositionTable = ({resultsTable,numDays,variant,title}) => {
	const isSmallScreen=useIsSmallDown();
	const maxPositions=isSmallScreen?3:99;
	const maxPositionsPixels=800;
	var results={};
	var maxPosition=0;
	Array.from(resultsTable).forEach((result) => {
		if (results[result.date]===undefined) {
			results[result.date]={};
			results[result.date].host=result.host;
			results[result.date].games=[];
		}
		if (results[result.date].games[result.gameNumber-1]===undefined) {
			results[result.date].games[result.gameNumber-1]={};
		}
		if (result.position>0)
			results[result.date].games[result.gameNumber-1][result.position-1]=result.name;
		maxPosition=Math.max(maxPosition,result.position);
	});
	maxPosition=Math.min(maxPosition,maxPositions);
	const ordinalColumnHeaders = ordinalList(maxPosition);
	const dates=Object.keys(results).slice(-numDays);

	const resultsRows = dates.map( (date) =>  {
		return(
			<Fragment key={date}>
				{Array.from(results[date].games).map( (game,gameNum) => 
					<TableRow key={gameNum}>
						{gameNum===0 && <TSCell rowSpan={results[date].games.length}>{dateFormatter(date)}</TSCell>}
						{gameNum===0 && !isSmallScreen && <TSCell rowSpan={results[date].games.length}>{results[date].host}</TSCell>}
						{variant!=="minimal" && <TSCell>{gameNum+1}</TSCell>}
						{Array.from({length:maxPosition},(_,i)=>i).map((pos) =>
							<TSCell key={pos} sx={{width:`${maxPositionsPixels/maxPosition}px`}}>{game[pos]}</TSCell>
						)}
					</TableRow>
				)}
			</Fragment>
		)
	});

	const headings=["Date"];
	if (!isSmallScreen)
		headings.push("Venue");
	if (variant!=="minimal")
		headings.push("Game");
	headings.push(...ordinalColumnHeaders);
	return(
		<TSTable headings={headings} title={title}>
			{resultsRows}
		</TSTable>
	);
}

export default ResultsByPositionTable;